export enum LookupSpecialFields {
  CurrentActorFullName = 'CurrentActorName',
  CurrentActorEmail = 'CurrentActorEmail',
  InitiatorFullName = 'Initiator',
  InitiatorEmail = 'InitiatorEmail'
}
